import _ from 'underscore';
import UsersAndGroupsListEntry from './users-and-groups-list-entry';

function UsersAndGroupsList({ entries, activeIndex, onEntryClick, whiteBackground }) {
  return (
    <ul className="users-and-groups-list">
      {_.map(entries, (entry, index) => (
        <UsersAndGroupsListEntry
          key={index}
          isActive={index === activeIndex}
          entry={entry}
          onEntryClick={onEntryClick}
          whiteBackground={whiteBackground}
        />
      ))}
    </ul>
  );
}

export default UsersAndGroupsList;
